import { useCallback, useMemo } from 'react';

/**
 * Compatibility hook that provides a Next.js-like router API.
 * Uses window.location to work both inside and outside RouterProvider context.
 */
export function useRouter() {
  const push = useCallback((path: string) => {
    window.location.href = path;
  }, []);

  const replace = useCallback((path: string) => {
    window.location.replace(path);
  }, []);

  const back = useCallback(() => {
    window.history.back();
  }, []);

  const forward = useCallback(() => {
    window.history.forward();
  }, []);

  const refresh = useCallback(() => {
    window.location.reload();
  }, []);

  const prefetch = useCallback((_path: string) => {
    // No-op for window.location based router
  }, []);

  return useMemo(
    () => ({
      push,
      replace,
      back,
      forward,
      refresh,
      prefetch,
    }),
    [push, replace, back, forward, refresh, prefetch]
  );
}
